import { render, staticRenderFns } from "./BusinessApplicationPreview.vue?vue&type=template&id=77d451a5&scoped=true&"
import script from "./BusinessApplicationPreview.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./BusinessApplicationPreview.vue?vue&type=style&index=0&id=77d451a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d451a5",
  null
  
)

export default component.exports